export enum LocalStorageConstants {
  ACCESS_TOKEN = "access_token",
  TOKEN_TYPE = "token_type",
  USER_DATA = "user_data",
  SELECTED_USER_TYPE = "selected_user_type",
  IS_SESSION_EXPIRED = "is_session_expired",
  UI_CONFIG = "ui_config",
  ERROR_MESSAGE = "error-message",
  DATE_TIME_FILTER = "dateTimeFilter",
  TOKEN_EXPIRY_TIMESTAMP = "tokenExpiryTimeStamp",
  IS_TOKEN_EXPIRED = "isTokenExpired",
  IS_USER_ACTIVE = "isUserActive",
  TOP_BAR_FILTERS = "topbar-filters",
  MASTER_FILTERS = "master-filters"
}

export enum LocalStorageValueConstants {
  FALSE = "false",
  TRUE = "true"
}

